import { Box, Paper, Typography, Stack, Button, Container } from "@mui/material";
import { List, ListItem, ListItemText, ListItemIcon, IconButton, Link } from "@mui/material";

import { Link as RouterLink, Navigate } from "react-router-dom";

import KeyboardBackspace from '@mui/icons-material/KeyboardBackspace';
import AccountCircle from '@mui/icons-material/AccountCircle';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import recurringPlansIcon from '../../images/callRecordsIcon.svg';
import editProfileIcon from '../../images/editProfileIcon.svg';
import changePasswordIcon from '../../images/changePasswordIcon.svg';

import { useState, useEffect } from "react";
import { ENDPOINTS, BASE_URL_VOIPSWITCH, BASE_URL_VOIPSWITCH2 } from "../..";
import axios from "axios";
import { SHA1 } from "../../sha1";
import sha1 from 'js-sha1';

import ScrollToTopOnMount from "../scrolltoview";

export default function MyAccount() {
    const username = sessionStorage.getItem('login')
    const firstName = sessionStorage.getItem('firstName')
    const [acctBalance, setAcctBalance] = useState(sessionStorage.getItem('creditBalance'))
    const [phoneNumber, setPhoneNumber] = useState("...")

    const [loggedOut, setLoggedOut] = useState(false)
    
    useEffect(() => {
        axios.post(`${BASE_URL_VOIPSWITCH}${ENDPOINTS['getBalance']}`, {
            clientType: 32,
            clientId: sessionStorage.getItem('idClient'),
            login: sessionStorage.getItem('login')
        })
        .then((res) => {
            // console.log(res)
            sessionStorage.setItem('creditBalance', res['data']['creditBalance']);
            setAcctBalance(res['data']['creditBalance']);
        
            // console.log("Success")
        })
        .catch((err) => {console.log(err.message)})

        // // Get client Did
        let authorization = ""
        if (sessionStorage.getItem("password"))
            authorization = "Basic " + btoa(sessionStorage.getItem('login') + ":" + sha1(sessionStorage.getItem("password")))
        else alert('re-login to sync data')
        
        console.log(authorization)
        axios.post(`${BASE_URL_VOIPSWITCH2}${ENDPOINTS['getClientDid']}`, {
            onlyAssigned: false,
            resellerDb: ""
        }, { headers: { 
            "Authorization": authorization}
        })
        .then((res) => {
            // console.log(res)
            // console.log(res["data"]["data"][0]["phoneNumber"])
            setPhoneNumber(res["data"]["data"][0]["phoneNumber"])
        })
        .catch((err) => {console.log(err.message)})

        axios.post(`${BASE_URL_VOIPSWITCH}${ENDPOINTS['getTechPrefix']}`, {
            "clientId": sessionStorage.getItem('idClient'),
            "techPrefix": ""
        })
        .then((res) => {
            let first = res["data"]["techPrefix"].split('!')[1]
            let second = first.split(';')[0]

            if (phoneNumber == "...") setPhoneNumber(second)
        })
        .catch((err) => {console.log(err.message)})
    })

        
    const logout = () => {    
        sessionStorage.clear()
        setLoggedOut(true)
    }

    if (loggedOut) 
        return <Navigate to="/Signin" />

    else
    return (
        <Paper component="div"
            sx={{ display: 'flex', flexDirection: 'column',
            pt: 3, pb: 10, mt: 3, mx: 'auto', width: {xs: '90vw', sm: '600px'},
            borderRadius:4 }}>
        <ScrollToTopOnMount />
        <Box display='flex' px={3} pb={2} alignItems='center'>
            <RouterLink to='/Dashboard' state={{page: 'overview' }} style={{ textDecoration: 'none', marginTop: '-24px' }}>
                <KeyboardBackspace sx={{ position: 'absolute', color: 'black' }}/>
            </RouterLink>
            <Typography variant="h5" fontWeight={700} sx={{ mx: 'auto'}}>My Account</Typography>
        </Box>
        <Box bgcolor="#E2E2E2" width='100%' height='2px'></Box>

        <Box px={3}>
            <Stack direction='column' pt={2} textAlign="center">
                <Box fontSize="80px" >
                    <AccountCircle fontSize="inherit" />
                </Box>
                <Typography variant="h6" mt={-2} >{firstName || username}</Typography>
                <Typography variant="body2" color='#929292'>234{phoneNumber}</Typography>

                <Container  sx={{ display: 'flex', bgcolor: '#E7F7E1', borderRadius: 3, py: 1, mt: 3 }}>
                    <Box>
                        <Typography variant="body2" >Acct. Balance</Typography>
                        <Typography variant="h5" fontWeight={700}>$ {acctBalance}</Typography>
                    </Box>
                    <RouterLink to='/Dashboard' state={{page: 'addfunds' }} 
                                style={{ textDecoration: 'none', 
                                          padding: '0px', 
                                          marginTop: '-40px',
                                          marginLeft: 'auto'  }}>
                        <Button  color='success' variant="contained"
                        sx={{  mt: 5, py: 1.5, backgroundColor: '#8DC641', textTransform: 'none' }}>
                            Add Funds
                        </Button>
                    </RouterLink>
                </Container>            
                <List sx={{ width: '100%', bgcolor: 'transparent' }}>
                    <ListItem
                    key={0}
                    secondaryAction={
                        <IconButton aria-label="call records">
                            <RouterLink to='/Dashboard' state={{ page: 'recurringplans'}}>
                                <ArrowForwardIosIcon  sx={{color:"black"}} />
                            </RouterLink>
                        </IconButton>
                    }
                    sx={{ my: 2, bgcolor: 'background.paper', borderRadius: 3}}
                    >
                        <ListItemIcon>
                            <Box component='img'
                                 src={recurringPlansIcon} />
                        </ListItemIcon>    
                        <ListItemText sx={{ ml: -1 }} primary="Plans" />
                    </ListItem>
                    
                    <ListItem
                    key={1}
                    sx={{ my: 2, bgcolor: 'background.paper', borderRadius: 3}}
                    secondaryAction={

                        <IconButton aria-label="edit profile">
                            <RouterLink to='/Dashboard' state={{ page: 'editprofile'}}>
                                <ArrowForwardIosIcon  sx={{color:"black"}} />
                            </RouterLink>    
                        </IconButton>
                    }
                    >
                        <ListItemIcon>
                            <Box component='img'
                                    src={editProfileIcon} />
                        </ListItemIcon>  
                        <ListItemText sx={{ ml: -1 }} primary="Edit Profile" />
                    </ListItem>
                    <ListItem
                    key={2}
                    sx={{ my: 2, bgcolor: 'background.paper', borderRadius: 3}}
                    secondaryAction={
                        <IconButton aria-label="change password">
                            <RouterLink to='/Dashboard' state={{ page: 'changepassword'}}>
                                <ArrowForwardIosIcon  sx={{color:"black"}} />
                            </RouterLink>    
                        </IconButton>
                    }
                    >
                        <ListItemIcon>
                            <Box component='img'
                                 src={changePasswordIcon} />
                        </ListItemIcon>        
                        <ListItemText sx={{ ml: -1 }} primary="Change Password" />
                    </ListItem>
                </List>    

                <Box bgcolor="#F7F7F7" width='100%' height='10px'></Box>

                <Link
                onClick={logout}
                style={{ cursor: 'pointer', textDecoration: 'none', color: '#FF1515', marginTop: '20px' }}>
                        Log out
                </Link>
            </Stack>
        </Box>
    </Paper>
    )
}